<template>

  <header :class="colorBar">

    <div class="title">
      <a href="https://www.eosc-synergy.eu" target="_blank"> <img src="../../static/eosc-synergy-high-contrast.png" alt="EOSC synergy"></a>
      <router-link :to="isLogged? '/select-option/' : '/'">
        <span class="full name">Software Quality Assurance as a Service</span>
        <span class="short name">SQAaaS</span>
      </router-link>
    </div>

    <div class="links">
      <a class="documentation linkInPDF" href="https://docs.sqaaas.eosc-synergy.eu/" target="_blank"><span>Documentation</span></a>
      <div class="separator" />
      <a class="about linkInPDF" href="https://www.eosc-synergy.eu/about/" target="_blank"><span>About</span></a>
      <a class="quality linkInPDF" href="https://www.eosc-synergy.eu/technical-areas/quality/" target="_blank"><span>Quality</span></a>
      <a class="contact-us linkInPDF" href="https://www.eosc-synergy.eu/contact-us/" target="_blank"><span>Contact us</span></a>
    </div>

    <button v-if="isLogged" type="button" class="sign out hideInPDF" @click="logoutEGI()">Log Out <i class="fa fa-power-off"></i></button>
    <button v-else type="button" class="sign in hideInPDF" @click="loginEGI()">Sign In <i class="fa fa-power-off"></i></button>

  </header>

</template>

<script>

  import Services from '../services/services';
  import store from "@/store";

  export default {
    mixins: [ Services ],

    computed: {
      colorBar() {
        if (process.env.NODE_ENV === 'development') {
          if (process.env.VUE_APP_API === "https://api-dev.sqaaas.eosc-synergy.eu")        return "bg-blue-dev"
          if (process.env.VUE_APP_API === "https://api-staging.sqaaas.eosc-synergy.eu/v1") return "bg-blue-stage"
          if (process.env.VUE_APP_API === "https://api.sqaaas.eosc-synergy.eu/v1")         return "bg-blue-prod"
        }
        else return "bg-blue" // 'production'
      },
      isLogged(){
        return store.state.isLogged
      }
    },

  }

</script>

<style scoped>

  header {

    &.bg-blue       { background-color: #73bbdc; }
    &.bg-blue-prod  { background-image: linear-gradient(90deg, #791212 0%, #73BBDC 7%); }
    &.bg-blue-stage { background-image: linear-gradient(90deg, #1a5bb0 0%, #73BBDC 7%); }
    &.bg-blue-dev   { background-image: linear-gradient(90deg, #319a19 0%, #73BBDC 7%); }

    position: sticky;
    top: 0;
    z-index: 100;

    padding: 0.6em 5%;
    border-bottom: solid 1px #67A8C6;

    .title  { grid-area: title; }
    .links  { grid-area: links; }
    .sign   { grid-area: sign; }

    display: grid;
    grid: "title links sign" / 1fr max-content max-content;
    column-gap: 2em;

    a { color: white; }

    .title {
      display: flex;
      font-size: 1.75em;
      align-items: center;
      img{
        height: 38px;
        padding-right: 1em;
        transform: translateY(-2px);
      }
      .name{ font-weight: bold; }
      .short.name { display: none; }
    }

    .separator {
      height: 70%;
      border-left: solid 1px white;
    }

    .links {
      display: flex;
      align-items: center;
      column-gap: 1.3em;
      justify-self: center;
      a span { margin-right: 0.5em; }
    }

    .sign{
      background-color: #5dacd1;
      align-self: center;
      border: 1px solid white;
      border-radius: 5px;
      color: white;
      transition: color 0.2s, border-color 0.2s;
      i { padding-left: 0.3em; }
    }
    .sign.in {
      padding: .3rem 2rem;
      font-size: 1.25rem;
      font-weight: bold;
    }
    .sign.out {
      padding: .3em 1.5em;
    }
    .sign:hover {
      color: #AB0720;
      border-color: #AB0720;
    }

  }


  @media (max-width: 1150px) {
    header{
      grid: "title sign"
            " links links "
           / 1fr max-content;
      row-gap: 0.5em;
   }
  }
 @media (max-width: 930px) {
   header{
     .title{
      font-size: 1.4em;
     }
   }
 }
  @media (max-width: 600px) {
    header {
      .title {
        font-size: 1.75rem;
        .full.name { display: none; }
        .short.name { display: inline; }
      }
      .sign.in {
        font-size: 1rem;
        padding: .3rem 0.9rem;
      }
      .links {
        font-size: 0.9rem;
      }
    }
  }

</style>
